import { render, staticRenderFns } from "./UIModal.vue?vue&type=template&id=0945987a&scoped=true"
import script from "./UIModal.vue?vue&type=script&lang=js"
export * from "./UIModal.vue?vue&type=script&lang=js"
import style0 from "./UIModal.vue?vue&type=style&index=0&id=0945987a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0945987a",
  null
  
)

export default component.exports